// Lazysizes companion: handles lazy <video> unveil (lazysizes has no native
// video support) and rescans on Shopify theme-editor section reloads.
// Loaded with defer from layout/theme.liquid.

const unveilVideo = (video) => {
  if (!video || video.tagName !== 'VIDEO') return;

  const highResPoster = video.getAttribute('data-poster');
  if (highResPoster) video.poster = highResPoster;

  for (const source of video.querySelectorAll('source[data-src]')) {
    source.src = source.getAttribute('data-src');
    source.removeAttribute('data-src');
  }
  video.load();

  if (!video.hasAttribute('data-autoplay')) return;
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

  const tryPlay = () => {
    const p = video.play();
    if (!p?.catch) return;
    p.catch(() => {
      // iOS may refuse autoplay until the tab is foregrounded; retry once on the next visibility change.
      const onVis = () => {
        if (document.hidden) return;
        video.play().catch(() => {});
        document.removeEventListener('visibilitychange', onVis);
      };
      document.addEventListener('visibilitychange', onVis);
    });
  };
  video.addEventListener('canplay', tryPlay, { once: true });
  video.addEventListener('loadeddata', tryPlay, { once: true });
};

document.addEventListener('lazybeforeunveil', (e) => unveilVideo(e.target), { passive: true });

const rescan = () => window.lazySizes?.loader.checkElems();
document.addEventListener('DOMContentLoaded', rescan);
document.addEventListener('shopify:section:load', rescan);
